// tslint:disable
/**
 * Course API
 * Used for: - Manage courses - Manage course info - Manage students - Learning control 
 *
 * The version of the OpenAPI document: 2.6.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { LearningUnitProgressSessionResult } from './learning-unit-progress-session-result';

/**
 * **DEPRECATED!**
 * @export
 * @interface LearningUnitProgressSession
 */
export interface LearningUnitProgressSession {
    /**
     * 
     * @type {string}
     * @memberof LearningUnitProgressSession
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LearningUnitProgressSession
     */
    status: LearningUnitProgressSessionStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof LearningUnitProgressSession
     */
    canMoveOn: boolean;
    /**
     * 
     * @type {Date}
     * @memberof LearningUnitProgressSession
     */
    startedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof LearningUnitProgressSession
     */
    finishedAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof LearningUnitProgressSession
     */
    isFinished: boolean;
    /**
     * 
     * @type {LearningUnitProgressSessionResult}
     * @memberof LearningUnitProgressSession
     */
    result?: LearningUnitProgressSessionResult;
}

/**
    * @export
    * @enum {string}
    */
export enum LearningUnitProgressSessionStatusEnum {
    Launched = 'Launched',
    Completed = 'Completed',
    Passed = 'Passed',
    CompletedAndPassed = 'CompletedAndPassed',
    Failed = 'Failed',
    Waived = 'Waived',
    Abandoned = 'Abandoned',
    Satisfied = 'Satisfied',
    NotDefined = 'NotDefined'
}



